import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import TodoList from "./TodoList";

const Todo = () => {
  return (
    <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
      <Header />
      <hr className="mt-4" />
      <TodoList />
      <hr className="mt-4" />
      <Footer />
    </div>
  );
};

export default Todo;
